const isNotNull = (x) => x !== undefined && x !== null
const isNull = (x) => x === null || x === undefined

export {
  isNull,
  isNotNull
}
